import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import APIS from "@service/api";
import { getUser } from "@utils";

export const accountManagementApi = createApi({
	reducerPath: "accountManagementApi",
	refetchOnFocus: false,
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: false,
	baseQuery: fetchBaseQuery({
		baseUrl: APIS["account-api"],
		prepareHeaders: (headers) => {
			const user = getUser();

			if (user?.token) {
				headers.set("Authorization", `Bearer=${user.token}`);
			}

			return headers;
		},
	}),
	endpoints: (builder) => ({
		getUserProfile: builder.query({
			query: () => ({
				url: "profile",
				method: "GET",
			}),
			providesTags: ["UserProfile"],
		}),
		getLastLogin: builder.query({
			query: () => ({
				url: "lastLogin",
				method: "GET",
			}),
			providesTags: ["LastLogin"],
		}),
		getDailyMaxDeposit: builder.query({
			query: () => ({
				url: "dailymaxdeposit",
				method: "GET",
			}),
			providesTags: ["DailyMaxDeposit"],
		}),
		setDailyMaxDeposit: builder.mutation({
			query: ({ maxDailyDeposit }) => ({
				url: "dailymaxdeposit",
				method: "PUT",
				body: { maxDailyDeposit },
			}),
			invalidatesTags: ["DailyMaxDeposit"],
		}),
		deleteDailyMaxDeposit: builder.mutation({
			query: () => ({
				url: "dailymaxdeposit",
				method: "DELETE",
			}),
			invalidatesTags: ["DailyMaxDeposit"],
		}),
		updateUserProfile: builder.mutation({
			query: (payload) => ({
				url: "profile",
				method: "PUT",
				body: payload,
			}),
			invalidatesTags: ["UserProfile"],
		}),
	}),
});

export const {
	useGetUserProfileQuery,
	useGetLastLoginQuery,
	useGetDailyMaxDepositQuery,
	useSetDailyMaxDepositMutation,
	useDeleteDailyMaxDepositMutation,
	useUpdateUserProfileMutation,
} = accountManagementApi;
